import { Component, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';

@Component({
  selector: 'wonda',
  templateUrl: './wonda.component.html',
  styleUrls: ['./wonda.component.scss'],
  animations: fuseAnimations
})
export class WondaComponent {}
